module.exports = __webpack_public_path__ + "img/copy.a3b6f811.svg";